import script from "./MetasPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MetasPage.vue?vue&type=script&setup=true&lang=js"

import "./MetasPage.vue?vue&type=style&index=0&id=649d4376&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-649d4376"]])

export default __exports__